<template>
  <div class="comp-psap-card-dealer">
    <div
    v-bind:class="{
      blue: infoList.length > 0
    }"
    class="cards-category">
      <comp-icon
      v-bind:icon="'business'"
      v-bind:width="24"></comp-icon>
      <span style="margin-left: 0.2em;">Monitoring Station</span>
    </div>
    <template v-if="infoList.length > 0">
      <div
      v-on:click="onClickDealer" ontouchstart=""
      class="card-container">
        <div
        v-for="(info, index) in infoList"
        v-bind:key="index"
        class="card-info-item">
          <div class="item-title">{{info.title}}</div>
          <div class="item-content">{{info.content ? info.content : 'No data'}}</div>
        </div>
      </div>
    </template>
    <template v-else>
      <div class="no-info">No information</div>
    </template>
  </div>
</template>

<script>
import CompIcon from '@/components/CompIcon'
export default {
  name: 'comp-psap-card-dealer',
  components: {
    CompIcon
  },
  computed: {
    psapDealer: function () {
      return this.$store.getters.psapDealer
    }
  },
  data: function () {
    return {
      infoList: []
    }
  },
  watch: {
    psapDealer: function () {
      this.updateInfoList()
    }
  },
  created: function () {
    this.updateInfoList()
  },
  methods: {
    updateInfoList: function () {
      if (this.psapDealer) {
        this.infoList = []
        this.infoList.push({
          title: 'Name',
          content: this.psapDealer.dealerName
        })
        if (this.psapDealer.locationInfo) {
          this.infoList.push({
            title: 'Address',
            content: this.psapDealer.locationInfo.address
          })
        }
        if (this.psapDealer.contactInfo) {
          this.infoList.push({
            title: 'phone',
            content: this.psapDealer.contactInfo.phone
          })
          this.infoList.push({
            title: 'email',
            content: this.psapDealer.contactInfo.email
          })
        }
      }
    },
    onClickDealer: function () {
      this.$emit('onClickDealer', {
        name: this.psapDealer.dealerName,
        phone: this.psapDealer.contactInfo.phone,
        email: this.psapDealer.contactInfo.email
      })
    }
  }
}
</script>

<style scoped>
.comp-psap-card-dealer {
  /* common */
  overflow: hidden;
  /* text */
  text-align: left;
  /* size */
  margin: 3px;
  margin-top: 1em;
  /* shape */
  border-radius: 4px;
}

.comp-psap-card-dealer .cards-category {
  /* common */
  font-size: 0.8em;
  background-color: #333;
  color: #fff;
  /* text */
  text-transform: uppercase;
  font-weight: bold;
  /* size */
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
}
.comp-psap-card-dealer .cards-category.blue {
  /* common */
  background-color: hsla(202, 100%, 50%, 1);
}

.comp-psap-card-dealer .no-info {
  /* common */
  background-color: #fff;
  color: #aaa;
  /* size */
  height: 4em;
  padding: 0.5em;
  /* alignment */
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}

.comp-psap-card-dealer .card-container {
  /* common */
  background-color: #fff;
  color: #000;
  /* mouse */
  cursor: pointer;
  /* size */
  padding: 0.5em 0;
}
.comp-psap-card-dealer .card-container:hover {
  /* common */
  background-color: hsla(0, 0%, 95%, 1);
}

.comp-psap-card-dealer .card-container .card-info-item {
  /* size */
  padding: 0.2em 0.5em;
}

.comp-psap-card-dealer .card-container .card-info-item .item-title {
  /* common */
  font-size: 0.5em;
  /* text */
  text-transform: uppercase;
  /* size */
  padding: 0 5px;
}

.comp-psap-card-dealer .card-container .card-info-item .item-content {
  /* size */
  padding: 0 5px;
}

</style>



// WEBPACK FOOTER //
// src/components/CompPsapCardDealer.vue